import { useTranslation } from "react-i18next"
import { TableCell, TableRow, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { GenericTable } from "../GenericTable/GenericTable";
import { GetOrganizationAdminUsers } from "../../../../../services/OrganizationServices";


interface IPrivilegesRow{
    title: string;
    subtitle: string;
}
const PrivilegesRow:React.FC<IPrivilegesRow> = ({title,subtitle}) => {
    const { t } = useTranslation();
    
    return (
        <>
        <TableRow>
            <TableCell>
            </TableCell>
            <TableCell sx={{width: '100%'}}>
                    <Typography sx={{ font: 'normal normal 600 14px/21px Segoe UI'}}>
                        {title}
                    </Typography>
                    <Typography sx={{ font: 'normal normal normal 14px/21px Segoe UI', opacity: 0.6 }}> 
                        {subtitle}
                    </Typography>
            </TableCell>
        </TableRow>
        </>
    )
};

export const PrivilegesTable = () => {

    const {t} = useTranslation();
    const {nameOrg} = useParams();
    const headers = [t('AdminConsole.Name') ]
    const [rootUsers, setRootUsers] = useState<number>(0)
    const bodyData = [
        {
            title: "Root",
            subtitle: t("AdminConsole.RootSubtitle"),
        },

        {
            title: t("AdminConsole.Organizer"),
            subtitle: t("AdminConsole.OrganizerSubtitle"),
        },
        {
            title: "Editor",
            subtitle: t("AdminConsole.EditorSubtitle"),
        },
        {
            title: t("AdminConsole.Reader"),
            subtitle: t("AdminConsole.ReaderSubtitle"),
        },
        {
            title: t("Privileges.Common"),
            subtitle: t("Privileges.CommonBehavior"),
        },
    ]

    useEffect(() => {

        if(nameOrg){
            GetOrganizationAdminUsers(nameOrg)
            .then((data) => setRootUsers(data.length))
            .catch((err) => console.error(err))
        }

    }, [nameOrg])

    return (
            <GenericTable
                headers={headers}
                bodyData={bodyData.map((data) => <PrivilegesRow title={data.title} subtitle={data.subtitle}/>) }
                isGroupPage={false}
            />
    )
}